/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import NumberFormat from 'react-number-format';
import { numberFormat, numberFormatDecimals } from 'constants/formats';

type BeneficiaryListMetricsCardProps = {
  title: string;
  value: number;
  useDecimals?: boolean;
  suffix?: string;
  colSize?: number;
};

const BeneficiaryListMetricsCard: FC<BeneficiaryListMetricsCardProps> = ({
  title,
  value,
  useDecimals = false,
  suffix = '',
  colSize = 4,
}) => {
  const formatConfig = useDecimals ? numberFormatDecimals : numberFormat;

  return (
    <div className={`col-${colSize}`}>
      <div className="analytic-ov">
        <div className="analytic-data-group analytic-ov-group w-100">
          <div className="analytic-data analytic-ov-data w-100 text-left">
            <div className="title">{title}</div>
            <div className="amount">
              <NumberFormat
                value={value || 0}
                displayType="text"
                {...formatConfig}
              />
              {suffix}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeneficiaryListMetricsCard;
